<template>
  <div class="correct-insured section_">
    <correct-title title="被保人员清单" />
    <div class="insured-content">
      <a-table :columns="columns" :data-source="batchInsureList" :row-key="(record, i) => record.name + '_' + i" :pagination="false" bordered>
        <template v-for="(item, index) in columns" :slot="item.dataIndex" slot-scope="text, record">
          <span :key="index" v-if="item.scopedSlots && item.renderFn">{{ item.renderFn(text, record) }}</span>
        </template>
        <template slot="operation" slot-scope="text, record, index">
          <a-button class="edit-btn" type="link" @click="edit(record, index)">
            修改
          </a-button>
          <a-button v-if="!record.insureId" class="del-btn" type="link" @click="del(index)">
            删除
          </a-button>
        </template>
      </a-table>
      <div v-if="hasAdd" class="btn-div">
        <a-button class="add-btn" icon="plus" @click="add()">新增被保人</a-button>
      </div>
    </div>

    <!-- 新增、修改被保人弹窗 -->
    <a-modal class="editModal_" :width="750" destroyOnClose v-model="showOrHide" okText="保存" :footer="false">
      <edit-insured ref="editInsured" :operateType="type" :effectiveDate="effectiveDate" :editIndex="editIndex" :insuredData="insuredData" :editCfg="insuredCfg" @onSave="onSave"></edit-insured>
    </a-modal>
  </div>
</template>

<script>
import { insuredMixins } from '@/views/correct/mixins/insuredMixins';
import correctTitle from './title';
import editInsured from './editInsured';
import commonMethods from '../common/methods.js';
import moment from 'moment';
export default {
  name: 'insured',
  mixins: [insuredMixins],
  components: {
    correctTitle,
    editInsured
  },
  props: {
    // 保单form数据
    batchInsureList: {
      type: Array,
      default: () => []
    },
    // 被保人配置项数据
    insuredCfg: {
      type: Object,
      default: () => {}
    },
    // 保单生效日期
    effectiveDate: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      saveType: 0, // 保存类型（1：新增；2：修改）
      showOrHide: false, // 弹窗是否显示字段
      insuredData: {}, // 当前操作的被保人数据
      editIndex: -1 // 修改的数据索引
    };
  },
  computed: {
    // 被保人表格表头数据
    columns() {
      // 被保人表格字段配置
      const columns = [
        {
          title: '姓名',
          dataIndex: 'name'
        },
        {
          title: '证件类型',
          dataIndex: 'idType',
          scopedSlots: { customRender: 'idType' },
          renderFn: (this.insuredCfg && this.insuredCfg.tableRender && this.insuredCfg.tableRender.idTypeRender) || this.idTypeRender
        },
        {
          title: '证件号码',
          dataIndex: 'idNumber'
        },
        {
          title: '出生日期',
          dataIndex: 'birthDate'
        },
        {
          title: '性别',
          dataIndex: 'gender',
          scopedSlots: { customRender: 'gender' },
          renderFn: commonMethods.genderRender
        },
        {
          title: '手机号',
          dataIndex: 'mobile'
        },
        {
          title: '批改生效',
          dataIndex: 'batchDate'
        },
        {
          title: '保费',
          dataIndex: 'premium',
          scopedSlots: { customRender: 'premium' },
          renderFn: commonMethods.premiumRender
        },
        {
          title: '批改类型',
          dataIndex: 'correctType'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 110,
          scopedSlots: { customRender: 'operation' }
        }
      ];
      return columns;
    }
  },
  methods: {
    // 新增被保人
    add(insuredData, index) {
      this.type = 1;
      // 修改被保人信息和新增被保人不可同时进行
      if (this.saveType === 2) {
        this.$message.error('当前已修改被保人信息，不可同时新增被保人');
        return false;
      }
      // 调用父组件初始化新增被保人字段配置
      if (this.$parent.$parent.openInsured) {
        this.$parent.$parent.openInsured(insuredData, 'add');
      }
      this.showOrHide = true;
      this.editIndex = index || -1;
      this.insuredData = insuredData || this.insuredCfg.addInitData;
    },
    // 修改按钮事件
    edit(data, index) {
      // 如果被保人id为空，说明是修改新增被保人数据，则调用新增弹窗
      if (!data.insureId) {
        this.add(data, index);
        return false;
      }
      this.type = 2;
      // 新增被保人和修改被保人信息不可同时进行
      if (this.saveType === 1) {
        this.$message.error('当前有新增被保人，不可同时修改被保人数据');
        return false;
      }
      this.showOrHide = true;
      this.editIndex = index;
      this.insuredData = data;
      // 调用父组件初始化新增被保人字段配置
      if (this.$parent.$parent.openInsured) {
        this.$parent.$parent.openInsured(data, 'edit');
      }
    },
    // 删除按钮事件（删除新增的被保人）
    del(index) {
      const that = this;
      this.$Modal.confirm({
        title: '删除被保人',
        content: '是否确定删除该被保人？',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          that.$emit('delAddInsured', index);
        },
        onCancel() {}
      });
    },
    // 修改保存事件触发
    onSave(data, index) {
      this.saveType = this.type;
      let msg = '';
      data.birthDate = moment(data.birthDate).format('YYYY-MM-DD');
      data.batchDate = moment(data.batchDate).format('YYYY-MM-DD');
      if (this.saveType === 1) {
        msg = index < 0 ? '新增成功!' : '修改成功!';
        data.correctType = '新增';
        // 如果index存在，则说明是修改新增的被保人数据
        if (index >= 0) {
          this.batchInsureList[index] = Object.assign(this.batchInsureList[index], data);
        }
      } else {
        msg = '修改成功!';
        data.correctType = '修改';
        this.batchInsureList[index] = Object.assign(this.batchInsureList[index], data);
      }
      this.$emit('insuredSave', this.type, data, index);
      this.$message.success(msg);
      this.showOrHide = false;
    },
    // 证件类型渲染函数
    idTypeRender(val) {
      // 调用公共证件类型渲染方法
      return commonMethods.idTypeRender(val);
    }
  }
};
</script>

<style lang="scss">
.correct-insured {
  .insured-content {
    margin-top: 15px;
    th {
      padding: 9px 16px !important;
    }
    td {
      padding: 3px 16px !important;
    }
    .edit-btn {
      padding: 0;
    }
    .del-btn {
      padding-left: 10px;
      padding-right: 0;
    }
  }
  .btn-div {
    margin: 20px 0;
    .add-btn {
      border: 1px solid #fe8f2d;
      color: #fe8f2d;
    }
  }
}

.editModal_ {
  .edit-save-box {
    text-align: center;
    .edit-save {
      width: 142px;
      font-size: 12px;
      background: #ff3600;
      border-radius: 3px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      color: #ffffff;
      line-height: 17px;
    }
  }
}
</style>
